var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"seasonDial"},[_c('img',{style:([{'--angle' : _vm.currentAngle + 'deg'}]),attrs:{"src":_vm.dial}})])}
var staticRenderFns = []

export { render, staticRenderFns }